import { ObservableFromFetch } from "../ObservableFromFetch"

interface LogData {
  Url?: string,
  Message?: string
  Exception?: string
  Stack?: string | string[]
  ComponentStack?: string
  WindowWidth: number
  WindowHeight: number
}

export default function LogErrorToServer(error: Error, info?: React.ErrorInfo) {
  PostLogData(error, info)
}

function PostLogData(error: Error, info?: React.ErrorInfo) {
  const data: LogData = {
    Url: location.href,
    Exception: error.message,
    Stack: error.stack,
    ComponentStack: info?.componentStack,
    WindowWidth: window.screen.availWidth,
    WindowHeight: window.screen.availHeight
  }
  const requestBody = JSON.stringify(data)
  return ObservableFromFetch<string>("Log/WriteUILog", requestBody).subscribe(() => { }, error => { } )
}

window.onerror = function (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) {
  // if (__DEVELOPMENT__) { // default error handling of the browser
  //   return false;
  // }
  if (!error) {
    return
  }
  PostLogData(error)

  return true;
};
